"use client";

import dynamic from "next/dynamic";

const VoiceChangerDemo = dynamic(() => import("./VoiceChangerDemo"));

export default VoiceChangerDemo;
